//What a SIM order costs. Browser-safe like the other common_*.js files: sim-order.svelte shows this
//number, and sim_orders.hooks.js charges it - the browser's own `price` is never trusted.
//
//SIM_Card_Needed_Count is one of "1","2","3","1-kosher","2-kosher","1-sim&1-kosher" (sim-order.svelte).

const SIM_PRICE = 49;
const JERUSALEM_DELIVERY_PRICE = 30;

function simOrderPrice(SIM_Card_Needed_Count, SIM_Delivery){
	if(!SIM_Card_Needed_Count) return 0;
	var count;
	if(SIM_Card_Needed_Count=="1-sim&1-kosher") count = 2;
	else count = parseInt(String(SIM_Card_Needed_Count)[0], 10);//first character is the count
	if(!(count >= 1 && count <= 3)) return 0;

	var price = SIM_PRICE * count;
	if(SIM_Delivery=='deliver-jerusalem') price += JERUSALEM_DELIVERY_PRICE;
	return price;
	}

module.exports = {simOrderPrice, SIM_PRICE, JERUSALEM_DELIVERY_PRICE};
